<div class="video-popup--header">
    <span>Learn how it works?</span>
    <i class="btn-close" (click)="onNoClick()"></i>
</div>
<mat-dialog-content>
    <div class="video-player--wapper">
        <!--<video controls autoplay>
        <source src="assets/videos/marihub.mp4" type="video/mp4">
        Your browser does not support the video tag.
    </video>-->

        <iframe src="https://www.youtube.com/embed/QDqJNZQirbg" title="Introducing Marihub Marketplace" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
    </div>
</mat-dialog-content>
<div class="video-popup--actions" *ngIf="userDetailsService.user.displayBoardingVideo === true">
    <button class="btn btn-secondary" (click)="onSubmit(guide.NEED_HELP)">
        I still need help! 🤚
    </button>
    <button class="btn btn-primary" (click)="onSubmit(guide.GOT_IT)">
        I got it 👍
    </button>
</div>
